// extracted by mini-css-extract-plugin
export default {"navigation_container":"NavigationTitle_navigation_container__UEoRT","back_icon":"NavigationTitle_back_icon__i3hG+","text_container":"NavigationTitle_text_container__325V3"};